import "../../css/main_form.less"

var ajaxProvinces = []
var ajaxCities = []
var ajaxColonies = []
var ajaxZips = []
var translateDict = {}
// for new select disable
var zip_placeholder = ''
var colony_placeholder = ''
window.step_required_fields = ["loan_purpose"]
var backendurl = (window.backendurl ? window.backendurl : 'https://staging.leadgen.crezu.net/')
// for trick with new redirect
window.new_tab_win = ''
window.autocompleteData = ''

var user_fingerprint = 'default'
var fingerprint_ready = false
window.preloader_phrases = ["Cargando, por favor espera...", "Estamos procesando tu solicitud", "Mantén esta ventana abierta", "Quéda poco para saber la respuesta"]
window.is_iframe = window.location.href.indexOf(".crezu.net/iframe") > -1
window.is_staging = (window.location.hostname.indexOf('staging.crezu.net') > -1 || window.location.hostname === 'localhost')
window.formFillStart = (Date.now() / 1000 | 0)
console.log("is iframe:", is_iframe)
window.formFillingHistoryStatus = 'formFillingHistoryDropped'
var sendLeadIDGAFlag = false
var readyState = false
var standartFlow = true
// window.carFieldsHardcore = ['plate_number', 'car_km', 'car_brand', 'car_model', 'car_year_registration', 'car_financing']
window.carFieldsHardcore = ['plate_number']


import {makeFieldsFromObject, setUpDeviders} from './fields/fields_generator'
import {showLoader, hideLoader} from './components/preloader'
import {
  userActionsDict, historyToDataLayer, resetUserActions, initActionsLIsteners, enterField_timing,
  fieldsTimingInit, leaveField_timing
} from './analytics/ga_events'
import {
  detectDevice, swapDict, GetURLParameter, getCookie, setCookie, updateFirebaseTokenWithLeadId,
  mGidLead, proceedRedirect, successRedirectPrepare, redirectSwitch, hardRefreshPage, pushFBEvent, pushGTMEvent, pushVKEvent,
  setLeadId, getDPI, getScreenSize, dispatchCrezuEvent, beforeUnloadListener,
  initUTM, updateInputsDataFromURL
} from './components/helpers'
import { lenderPickerPrepare, renderLenderPicker, lenderPickerLinking } from './components/lenderPicker'
import { goToFeed, goToFeedPromo } from './components/redirectToFeed'
import {secondStepPrepareAfterAuth, authAnalyticsEvents} from './auth/auth_step_prepare'
import {
  validate,
  trigger_success,
  trigger_percentreward,
  trigger_err,
  calculateProgressbar,
  clearProgressbar
} from './components/triggers_and_progressbar'
import {CCCToIBAN} from './fields/handlers/handlers'
import {initCircleProgress} from './components/circleProgress'
import {newRedirectPopup} from './components/redirectPopup'

if (window.interface_v2) initCircleProgress()

window.onbeforeunload = function () {
  return '¿De verdad quieres cerrar esta página?';
};
if (is_iframe) {
  window.onbeforeunload = null
}

window.addEventListener("beforeunload", function () {
  beforeUnloadListener()
})


jQuery(function ($) {
  // FB event when reg form is loaded
  pushFBEvent('track', 'ViewContent', {content_name: 'Reg'})
  pushGTMEvent({'event': 'Reg'})
  pushVKEvent('page_view')
  window.$ = $

  var cCode = $("[name=country]").val()
  window.country = {
    is_ES: cCode == '1',
    is_MX: cCode == '2',
    is_PH: cCode == '3',
    is_AR: cCode == '4',
    is_PE: cCode == '5',
    is_CO: cCode == '6',
    is_UA: cCode == '7',
    is_KZ: cCode == '8',
    is_VN: cCode == '9'
  }

  localStorage.setItem('provider', $("[name=provider]").val())
  localStorage.setItem('country', $("[name=country]").val())

  // if JWT (auth_token) in localStorage - send it after fingerprint get to backend and try to auth
  function checkToken() {
    if (GetURLParameter('lead_id')) {
      // not standart flow
      // prevent creating of sending check-token and creating new LEAD ID
      console.warn('prevent creating of new lead_id')
      return
    }
    localStorage.removeItem('JWTAutocomplete')
    if (localStorage.getItem("auth_token") && !localStorage.getItem('authAutocomplete')) {
      $.ajax({
        url: backendurl + '/check-token',
        type: 'post',
        dataType: 'json',
        data: {
          fingerprint: user_fingerprint,
          loan_sum: ($('[name=loan_sum]').val()) ? $('[name=loan_sum]').val().split(window.override_sum_separator || ' ').join('') : fields_json.params.loan_sum.min,
          loan_period: ($('[name=loan_period]').val()) ? $('[name=loan_period]').val() : 30,
          utm_source: $('#utm_source').val(),
          utm_medium: $('#utm_medium').val(),
          utm_campaign: $('#utm_campaign').val(),
          utm_content: $('#utm_content').val(),
          utm_term: $('#utm_term').val(),
          country: $('[name=country]').val(),
          provider: $('[name=provider]').val(),
          ga_client_id: $('#ga_client_id').val(),
          gclid: $('#gclid').val(),
          ttclid: GetURLParameter('ttclid') || getCookie('ttclid') || '',
          kwaiclid: getCookie('kwaiclid') || '',
          device: detectDevice(),
          domain: $('[name=domain]').val(),
          exp_flow: GetURLParameter('exp_flow') || ''
        },
        xhrFields: {
          withCredentials: true
        },
        beforeSend: function (request) {
          request.setRequestHeader("Auth-Token", localStorage.getItem("auth_token"));
          request.setRequestHeader("Access-Control-Allow-Credentials", "true");
        },
        success: function (data) {
          setLeadId(data.data.lead_id);
          localStorage.setItem('lead_status', data.data.lead_status)

          function runJWTAutocompletePrepare() {
            localStorage.setItem('JWTAutocomplete', JSON.stringify(data.data.customer))
            // waiting for initFront() is ready
            var readyInterval = setInterval(function () {
              if (readyState) {
                clearInterval(readyInterval)
                if (standartFlow) {
                  processAuthAutocomplete(data.data.customer)
                }
              }
            }, 100)
          }

          runJWTAutocompletePrepare()
        },
        error: function (e) {
          console.log('remove loader from JWT auth, cause error')
          $('#loader').remove();
          dispatchCrezuEvent('formLoaded')
        }
      })
    }
  }

  // fingerprint init, next we push it in each request
  function getFingerprint() {
    $.getScript(globalConfig.origin + "/native/js/fingerprint2.min.js", function (data, textStatus, jqxhr) {
      if (window.requestIdleCallback) {
        requestIdleCallback(function () {
          Fingerprint2.getV18({}, function (result, components) {
            fingerprint_ready = true
            user_fingerprint = result
            checkToken()
          })
        })
      } else {
        setTimeout(function () {
          Fingerprint2.getV18({}, function (result, components) {
            fingerprint_ready = true
            user_fingerprint = result
            checkToken()
          })
        }, 500)
      }
    });
  }

  // Basic variables
  window.progress_bar = [];
  window.curr_step = 1;

  if (GetURLParameter('f_l')) {
    console.log('don\'t init sbjs')
    sbjs.init({domain: 'f_l'})
  } else {
    console.log('init sbjs')
    sbjs.init({})
  }

  initUTM()

  var specific_providers = ['32', '33', '34', '35', '63']
  if (window.location.hostname == 'localhost') {
    var config_by_provider = '/configs/' + $("[name=provider]").val() + ".json"
    var config_by_country = '/configs/default_country_profiles/' + $("[name=country]").val() + '.json'
  } else {
    var config_by_provider = globalConfig.origin + '/native/configs/' + $("[name=provider]").val() + ".json"
    var config_by_country = globalConfig.origin + '/native/configs/default_country_profiles/' + $("[name=country]").val() + '.json'
  }
  var url = (specific_providers.indexOf($("[name=provider]").val()) > -1) ? config_by_provider : config_by_country

  // Generate fields in code
  $('#link-redirect').trigger('click');
  $.ajax({
    url: url,
    type: 'get',
    dataType: 'json',
    complete: function (data) {
      getFingerprint()
      initActionsLIsteners()
      initFront(data)
    }
  })

  // send FORM_STEP_LANDED event
  $.ajax({
    url: 'https://events.crezu.net/api/event',
    type: 'post',
    dataType: 'json',
    contentType: "application/json; charset=utf-8",
    data: JSON.stringify({
      event_id: 21,
      sub1: GetURLParameter('lead_id') || localStorage.getItem('leadId'),
      sub2: GetURLParameter('exp_flow') || 0,
      provider_id: +$("[name=provider]").val(),
      session_id: getCookie('uuidv4') || generateUUIDv4(),
      domain: window.location.hostname,
      utm_source: $('#utm_source').val(),
      utm_medium: $('#utm_medium').val(),
      utm_campaign: $('#utm_campaign').val(),
      utm_content: $('#utm_content').val(),
      utm_term: $('#utm_term').val(),
    }),
    error: function(error) {
      console.error('event error:', error)
    }
  })

  if (GetURLParameter('utm_campaign')) {
    // send SITE_OPEN event if user traps directly to reg form (not from index)
    $.ajax({
      url: 'https://events.crezu.net/api/event',
      type: 'post',
      dataType: 'json',
      contentType: "application/json; charset=utf-8",
      data: JSON.stringify({
        event_id: 1,
        provider_id: +$("[name=provider]").val(),
        session_id: getCookie('uuidv4') || generateUUIDv4(),
        domain: window.location.hostname,
        utm_source: $('#utm_source').val(),
        utm_medium: $('#utm_medium').val(),
        utm_campaign: $('#utm_campaign').val(),
        utm_content: $('#utm_content').val(),
        utm_term: $('#utm_term').val(),
      }),
      error: function(error) {
        console.error('event error:', error)
      }
    })
  }

  function generateUUIDv4() {
    try {
      const uuidv4 = ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c => (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16))
      setCookie('uuidv4', uuidv4, 1 / 48)
      console.log('generate new session:', uuidv4)
      return uuidv4
    } catch (e) {
      console.log('error while record session ID', e)
    }
  }

  function initFront(data) {
    window.validate_rules = [];
    window.fields_json = JSON.parse(data.responseText)

    fields_json.params.birthday = fields_json.params.birthday || {
      "invalid_error": "Debes tener entre 18 y 100 años de edad",
      "default_error": "Por favor, introduce tu fecha de nacimiento"
    }

    makeFieldsFromObject(country);
    for (var i in fields_json.main_fields) {
      switch (fields_json.main_fields[i].name) {
        case 'province':
          ajaxProvinces = fields_json.main_fields[i].provinces
          break;
        case 'zip':
          zip_placeholder = fields_json.main_fields[i].label
          break;
        case 'colony':
          colony_placeholder = fields_json.main_fields[i].label
          break;
        default:
          if (fields_json.main_fields[i].type == 'new-select' && fields_json.main_fields[i].translate) {
            translateDict[fields_json.main_fields[i].name] = fields_json.main_fields[i].translate
          }
          break;
      }
    }
    preloader_phrases = fields_json.params.preloader_phrases
    $(window).resize(function () {
      resizeModals();
    });
    trigger_percentreward(false);

    updateInputsDataFromURL()

    // Get provider id from iframe
    $('.main_container_form').on('submit', function (e) {
      e.preventDefault();
      validateForm($(this));
    });

    if (country.is_MX) {
      // set MX zip validation
      zipHandlerMx();
    }
    if (country.is_ES) {
      // Generate ES province field with basic data
      generateProvinceField();
    }
    // Generate loan_purpose field with basic data
    var fieldsMass = Object.keys(translateDict)
    for (var i in fieldsMass) {
      generateNewSelectField(fieldsMass[i])
    }

    $('[name=confirm_email]').keyup(function () {
      if ($('[name=confirm_email]').val().length == 4 && step_required_fields.length == 1) {
        $('[name=confirm_email]').blur()
        call_ajax_form()
      }
    })
    if (GetURLParameter('confirm_email') != null && GetURLParameter('lead_id') != null) {
      standartFlow = false
      console.warn("CONFIRM EMAIL FLOW")
      $('.box-wrapper').addClass('hidden');

      function processEmailConfirm() {
        setupNextStep(["confirm_email"], GetURLParameter('lead_id'));
        $('.ui-form-progress-bar__progress_zebra').css('width', '50%');
        $('#email-copy').text(localStorage.getItem('email'));
        $('[name=confirm_email]').focus();
        $('[name=confirm_email]').val(GetURLParameter('confirm_email'));
        $('[name=confirm_email]').blur();
        trigger_success($(this).closest('.ui-form__field'));
        $('.app-form-action-agreement').css("display", "none");
        localStorage.setItem('leadId', GetURLParameter('lead_id'));
        localStorage.setItem('lead_id', GetURLParameter('lead_id'));
        $('#agreement').prop('checked', true);
        $('#agreement_2').prop('checked', true);
        call_ajax_form()
      }

      if ($('[name=provider]').val() == 2) { // country.is_ES
        console.log('START process user activation')
        $('body').append('<div class="confirm_email-preloader-page">\n' +
          '<div class="confirm_email-preloader">\n' +
          '<div class="confirm_email-preloader-line"></div>\n' +
          '</div>\n' +
          '<p class="confirm_email-preloader-text__l">¡Gracias, tu cuenta ha sido activada!</p>\n' +
          '<p class="confirm_email-preloader-text__s">Analizaremos la información que nos proporcionaste y en base a tus datos crearemos un algoritmo de búsqueda individual. Puede que necesitemos información adicional de tu parte.</p>\n' +
          '</div>')
        setTimeout(function () {
          processEmailConfirm()
          $('.confirm_email-preloader-page').remove()
        }, 10000)
      } else {
        processEmailConfirm()
      }
    } else if (GetURLParameter('confirm_email') == null && GetURLParameter('returned_user') == null && GetURLParameter('lead_id') != null) {
      standartFlow = false
      console.warn("WITH LEAD ID -> to /process FLOW")
      // if lead_id in url params - go to the second page (skip /form)

      if (GetURLParameter('f_l')) window.sendFLOnce = true
      $('.box-wrapper').addClass('hidden');
      setupNextStep([], GetURLParameter('lead_id'));
      $('.app-form-action-agreement').css("display", "none");
      $('.ui-form-progress-bar__progress_zebra').css('width', '50%');
      localStorage.setItem('leadId', GetURLParameter('lead_id'));
      localStorage.setItem('lead_id', GetURLParameter('lead_id'));
      var fingerprintTimeout
      var fingerprintInterval

      function afterFingerprint() {
        clearInterval(fingerprintInterval)
        clearTimeout(fingerprintTimeout)
        call_ajax_form()
      }

      fingerprintInterval = setInterval(function () {
        if (fingerprint_ready) {
          afterFingerprint()
        }
      }, 100)
      fingerprintTimeout = setTimeout(function () {
        if (!fingerprint_ready) {
          afterFingerprint()
        }
      }, 2000)
    } else if (GetURLParameter('returned_user') == true || GetURLParameter('returned_user') == "true") {
      standartFlow = false
      console.warn("VERIFY FLOW")
      // its returned user, next request is /verify
      $.each(["name", "surname", "surname_second", "birthday", "loan_purpose"], function (i, field) {
        $('[name=' + field + ']').attr('disabled', true)
        $('[name=' + field + ']').closest('.ui-form__row').addClass('hidden');
      })
      step_required_fields = [];
      $('.ui-form-progress-bar__hint .cont').hide();
      $('[name=loan_sum]').focus();
      if (GetURLParameter('lead_id')) {
        $('#lead_id_input').val(GetURLParameter('lead_id'));
      } else {
        $('#lead_id_input').val(localStorage.getItem('leadId') || localStorage.getItem('lead_id'));
      }
    } else {
      console.warn("STANDART FLOW")
      if (localStorage.getItem('authAutocomplete')) {
        let dtNow = Date.now() / 1000 | 0
        let lsData = JSON.parse(localStorage.getItem('authAutocomplete'))
        if (dtNow - lsData.timestamp < 60) {
          processAuthAutocomplete(lsData)
        } else {
          localStorage.removeItem('authAutocomplete')
        }
      }
    }
    $('#has_declined_confirm_email').click(function () {
      pushGTMEvent({
        'event': 'hasDeclinedConfirmEmail'
      })
      setCookie("has_declined_confirm_email", 1, 1)
      call_ajax_form(1)
    });
    $('#has_declined_IBAN').click(function () {
      $("[name=bank_account_number]").closest('.ui-form__row').addClass('hidden')
      $("[name=bank_account_number]").val("IGNORE")
      if (country.is_UA) {
        $("[name=id_number]").closest('.ui-form__row').addClass('hidden')
        $("[name=id_number]").val("IGNORE")
      }
      validateForm($('.main_container_form'))
      pushGTMEvent({
        'event': 'hasDeclinedIBAN'
      })
    });
    fieldsTimingInit()
    readyState = true
    if (!standartFlow) {
      console.log("remove loader cause not standart flow")
      $('#loader').remove();
      dispatchCrezuEvent('formLoaded')
    } else {
      setTimeout(function () {
        if (!localStorage.getItem("JWTAutocomplete") && !localStorage.getItem('authAutocomplete')) {
          pushGTMEvent({
            "event": "startedFromFirstStep"
          })
        }
      }, 5000)
    }
  }
});

// Validate all form fields and call sending function
function validateForm(element) {
  console.log(step_required_fields)
  var fields = element.find('[data-required]'),
    err = false,
    first = true;
  fields.each(function () {
    if ($(this).prop('disabled') || $(this).closest('.hidden').length > 0) {
      if (step_required_fields.indexOf($(this).attr('name')) > -1 && !validate($(this))) {
        err = true;
        trigger_err($(this).closest('ui-form__field'));
      } else {
        return
      }
    }
    ;
    if ($(this).attr('type') != 'checkbox' && $(this).attr('type') != 'radio' && !validate($(this))) {
      err = true;
      trigger_err($(this).closest('ui-form__field'));
    } else if ($(this).attr('type') == 'checkbox' && !$(this).prop('checked')) {
      // handler for optional prestamer marketing agreement
      if ($(this).attr('name') != 'prestamer_agreement3' && $(this).attr('name') != 'moneyman3') {
        err = true;
        trigger_err($(this).closest('.ui-form__field'));
      }
    } else if ($(this).attr('type') == 'radio') {
      var name = $(this).attr('name'),
        checked = false;
      $('[name=' + name + ']').each(function () {
        if ($(this).prop('checked')) checked = true;
      });
      if (!checked) {
        err = true;
        trigger_err($(this).closest('.ui-form__field'));
      }
    }
  });
  if (!err) {
    call_ajax_form();
  } else {
    $('.ui-form__row_default-error-view-visible').each(function () {
      if (first) {
        if ($('.ui-form__row_default-error-view-visible').find('input').attr('name') == "id_number") {
          $('html,body').stop().animate({
            'scrollTop': 0
          }, 300);
        } else {
          $('html,body').stop().animate({
            'scrollTop': $(this).offset().top - ($('.progress_bar_wrapper').length > 0 ? $('.progress_bar_wrapper').parent('.progress_bar_holder').outerHeight() : 0)
          }, 300);
        }
        first = false
      }
    })
  }
}

function call_ajax_form(flag) {
  // hide agreements checkboxes and MX repeat email field
  if (window.curr_step > 1) {
    $('#agreement').attr("disabled", true)
  }
  $('#agreement_2').attr("disabled", true)
  $('#additional-text-collapsible').addClass("hidden")
  $('[name=email_repeat]').attr("disabled", true)

  for (var i in step_required_fields) {
    $('[name=' + step_required_fields[i] + ']').attr('disabled', false)
  }

  // for Prestamer
  if (step_required_fields.indexOf('prestamer_agreement1') > -1) {
    $('[name=prestamer_agreement1]').attr('disabled', true)
    $('[name=prestamer_agreement2]').attr('disabled', true)
  }

  var postData = $('.main_container_form').serializeArray()
  // for Prestamer
  // if ((step_required_fields.indexOf('prestamer_agreement3') > -1) && !$('[name=prestamer_agreement3]').prop('checked')) {
  //     postData.push({name: 'prestamer_agreement3', value: 0});
  // }

  // for Moneyman
  if ((step_required_fields.indexOf('moneyman3') > -1) && !$('[name=moneyman3]').prop('checked')) {
    postData.push({name: 'moneyman3', value: false});
  }

  if (step_required_fields.indexOf('prestamer_agreement1') > -1) {
    postData.push({name: 'prestamer_agreements', value: 1});
  }

  //moneyman block
  if (step_required_fields.indexOf('moneyman_instantor') > -1) {
    postData.push({name: 'instantor_provided', value: !!+localStorage.getItem('instantor_provided')});
  }
  if (step_required_fields.indexOf('moneyman_paylands') > -1) {
    postData.push({name: 'paylands_provided', value: !!+localStorage.getItem('paylands_provided')});
    postData.push({name: 'paylands_required', value: localStorage.getItem('paylands_required')});
    postData.push({name: 'online_banking_provided', value: !!+localStorage.getItem('online_banking_provided')});
    postData.push({name: 'online_banking_required', value: localStorage.getItem('online_banking_required')});
    postData.push({name: 'juicescore_session_id', value: localStorage.getItem('juicescore_session_id')});
    postData.push({name: 'online_banking_id', value: localStorage.getItem('online_banking_id')});
  }

  //welp block
  if (step_required_fields.indexOf('welp_instantor') > -1) {
    postData.push({name: 'welp_instantor', value: !!+localStorage.getItem('instantor_provided')});
  }

  //welp wenance_bank_reader
  if (step_required_fields.indexOf('wenance_bank_reader') > -1) {
    postData.push({name: 'wenance_bank_reader', value: +localStorage.getItem('wenance_bank_reader')});
  }

  if (step_required_fields.indexOf('lender-picker') > -1) {
    for (let i in window.lenderPickerOffers) {
      let offer_id = GetURLParameter('offer_id', window.lenderPickerOffers[i].link)
      lenderPickerLinking(offer_id, (window.lenderPickerExcluded.indexOf(offer_id) > -1) ? '0' : '1')
    }
    localStorage.setItem('EO', window.lenderPickerExcluded.join('_'))
    pushGTMEvent({
      "event": "lenderPickerCompleted",
      "lead_id": localStorage.getItem('leadId') || localStorage.getItem('lead_id')
    })
  }

  // var method = ((window.curr_step > 1) ? '/process' : '/form');
  var method = "/process"

  if (window.curr_step == 1) {
    if (GetURLParameter('returned_user') == true || GetURLParameter('returned_user') == "true") {
      method = "/verify"
    } else {
      method = "/form"
    }
  }

  // fingerprint
  postData.push({name: 'fingerprint', value: user_fingerprint})

  // ttclid
  postData.push({name: 'ttclid', value: GetURLParameter('ttclid') || getCookie('ttclid') || ''})

  // kwaiclid
  postData.push({name: 'kwaiclid', value: getCookie('kwaiclid') || ''})

  // fake lead flag on process flow
  if (window.sendFLOnce) {
    postData.push({name: 'f_l', value: true})
    window.sendFLOnce = false // DONT SEND IT AGAIN
  }

  // skip email verify step
  method = method + (getCookie("has_declined_confirm_email") / 1 ? '?has_declined_confirm_email=1' : '');

  if (method.indexOf("/form") > -1) { //method == '/form'
    // new Android detector
    postData.push({name: 'device', value: detectDevice()})

    // facebook ids
    postData.push({name: 'fb_fpc', value: getCookie('_fbc')})
    postData.push({name: 'fb_fbp', value: getCookie('_fbp')})

    // screen info for antifrod
    postData.push({name: 'screen_size', value: getScreenSize()})
    postData.push({name: 'dpi', value: getDPI()})

    // custom param for trafficback
    const tf = GetURLParameter('tf') || getCookie('tf')
    if (tf) postData.push({name: 'tf', value: tf})

    // custom param for exp_flow
    const exp_flow = GetURLParameter('exp_flow')
    if (exp_flow) postData.push({name: 'exp_flow', value: exp_flow})

    // save this data for moneyman
    localStorage.setItem('firstName', $('[name=name]').val());
    localStorage.setItem('lastName', $('[name=surname]').val());
    // write loan sum and period to local storage
    localStorage.setItem('loan_sum', $('[name=loan_sum]').val())
    localStorage.setItem('loan_period', $('[name=loan_period]').val())
    // add loan sum and period to JWTAutocomplete
    if (localStorage.getItem('JWTAutocomplete')) {
      var autocompleteFields = JSON.parse(localStorage.getItem('JWTAutocomplete'))
      autocompleteFields['loan_sum'] = $('[name=loan_sum]').val()
      autocompleteFields['loan_period'] = $('[name=loan_period]').val()
      localStorage.setItem('JWTAutocomplete', JSON.stringify(autocompleteFields))
    }
    // for Resuelve only
    if ($("[name=provider]").val() == "8") {
      postData.push({name: 'other_loans_company', value: GetURLParameter('other_loans_company').replace(/%20/g, " ")})
      postData.push({name: 'other_loans_amount', value: GetURLParameter('other_loans_amount')})
    }
  }

  var i;
  for (i = postData.length - 1; i >= 0; i--) {
    if (postData[i].name === 'confirm_email') {
      if (getCookie("has_declined_confirm_email") / 1 && flag) {
        postData.splice(i, 1);
        // method+="?has_declined_confirm_email=1"

      } else {
        // check if only confirm_email field is rendered
        if (step_required_fields.length === 1 && step_required_fields[0] === 'confirm_email') {
          method = '/confirm'
        }
      }
    }
    if (postData[i].name === 'loan_period' && (country.is_AR || country.is_PE || $('[name=provider]').val() === '64')) {
      postData[i].value = (postData[i].value / 1) * 30;
    }
    if (postData[i].name === 'bank_account_number' && country.is_ES && postData[i].value.length === 20) {
      // convert CCC to IBAN
      postData[i].value = CCCToIBAN(postData[i].value, 'ES')
    }
    if (postData[i].name === 'email') {
      localStorage.setItem('email', $('[name=email]').val());
    }
    if (postData[i].name === 'birthday') {
      postData[i].value = $('[name=birthday]').val().split('/').join('-');
    }
    // if (postData[i].name === 'work_start_date') {
    //     postData[i].value = $('[name=work_start_date]').val().split('/').join('-');
    // }
    if (postData[i].name === 'work_start_month') {
      postData.splice(i, 1);
      postData.push({
        'name': 'work_start_date',
        'value': `01-${translateDict['work_start_month'][$('[name=work_start_month]').val()]}-${$('[name=work_start_year]').val()}`
      })
    }
    if (postData[i].name === 'work_start_year') {
      postData.splice(i, 1);
    }
    // if (postData[i].name.indexOf('prestamer_agreement') > -1) {
    //     postData[i].value = (postData[i].value=="on") ? 1 : 0
    // }
    // for Resuelve
    if (postData[i].name == 'has_other_loans') {
      if (postData[i].value == 0) {
        postData.push({
          'name': 'other_loans_amount',
          'value': '0'
        })
        if (country.is_MX) {
          postData.push({
            'name': 'other_loans_company',
            'value': 'Other'
          })
        }
      }
    }
    if (postData[i].name == 'has_car' && postData[i].value == 0) {
      for (let i in carFieldsHardcore) postData.push({
        'name': carFieldsHardcore[i],
        'value': '0'
      })
    }
    if (["moneyman1", "moneyman2", "moneyman3"].indexOf(postData[i].name) > -1) {
      postData[i].value = (postData[i].value == "on")
    }
    if (postData[i].name === 'phone' && method.indexOf("verify") > -1) {
      postData[i].value = $('[name=phone]').val().split(' ').join('');
    }
    if (postData[i].name == 'ar-phone') {
      postData.splice(i, 1);
      postData.push({
        'name': 'phone',
        'value': '+54' + $('[name=ar-phone-code]').val() + $('[name=ar-phone]').val()
      })
    }
    if (postData[i].name == 'ar-phone-code') {
      postData.splice(i, 1);
    }
    if (postData[i].name == 'phone' && country.is_VN) {
      postData[i].value = '+84' + $('[name=phone]').val().split(' ').join('')
    }
    if (postData[i].name == 'loan_sum') {
      postData[i].value = $('[name=loan_sum]').val().split(window.override_sum_separator || ' ').join('')
    }

    var fieldsMass = Object.keys(translateDict)
    for (var f in fieldsMass) {
      if (postData[i].name === fieldsMass[f]) {
        postData[i].value = translateDict[postData[i].name][$('[name=' + postData[i].name + ']').val()]
      }
    }
  }

  function sendRequest() {
    $.ajax({
      url: backendurl + method,
      type: 'post',
      dataType: 'json',
      data: postData,
      success: function (data) {
        hideLoader()
        $('.ui-form__row_checkbox').css("display", "none");
        if (data.is_success) {
          var res = data.data;
          setLeadId(res.lead_id);
          if (res.auth_token) {
            localStorage.setItem("auth_token", res.auth_token)
          }
          // track all user actions for Dasha
          userActionsDict["lead_id"] = res.lead_id
          userActionsDict["duration"] = (Date.now() / 1000 | 0) - formFillStart
          pushGTMEvent(userActionsDict);
          // and reset counters
          resetUserActions()

          if (method.indexOf("/process") > -1 && !window.applicationSubmitted) {
            pushGTMEvent({
              'event': 'applicationSubmitted'
            });
            window.applicationSubmitted = true
          } else if (method.indexOf("/form") > -1) {
            pushGTMEvent({
              'event': 'FirstStepSubmitted'
            });
            if (res.lead_status === '1') pushGTMEvent({'event': 'FirstStepSubmittedNew'});
            if (window.location.hostname === 'crezu.es') {
              console.log('track MGid');
              mGidLead()
            }
            // FB event when lead complete first step
            pushFBEvent('track', 'Lead', {status: res.lead_status})
            // VK event lead
            pushVKEvent('lead')

            if (window.location.hostname === "crezu.kz") {
              var _tmr = window._tmr || (window._tmr = []);
              _tmr.push({id: "3162810", type: "reachGoal", goal: "lead", value: 1});
            }

            // lender-picker block
            if (country.is_VN || country.is_KZ || country.is_UA || country.is_MX) {
              lenderPickerPrepare(res)
              return
            }
          }
          if (step_required_fields.indexOf("id_number") > -1) {
            pushGTMEvent({
              "event": "TimeSecondStepSubmitted",
              "value": (Date.now() / 1000 | 0) - formFillStart,
              "lead_id": res.lead_id
            });
            if ((localStorage.getItem('authAutocomplete') || localStorage.getItem('JWTAutocomplete'))) {
              pushGTMEvent({
                "event": "authorisedAndSubmitIdNumber"
              });
            }
          }
          if (!sendLeadIDGAFlag) {
            const leadId = localStorage.getItem('leadId') || localStorage.getItem('lead_id')
            pushGTMEvent({
              'event': 'trackerReady',
              'loadedWithLeadId': ((leadId != null) ? 1 : 0),
              'lead_id_in': leadId,
              'lead_id_out': res.lead_id
            });
            sendLeadIDGAFlag = true
          }

          // update FCM token with actual leadId
          updateFirebaseTokenWithLeadId()

          if (res.display == 'form') {
            setupNextStep(res.fields, res.lead_id);
          } else if (res.display == 'confirm_email') {
            setupNextStep(res.fields, res.lead_id);
          } else if (res.display == 'iframe') {
            // FB event when we redirect lead to lender
            pushFBEvent('track', 'CompleteRegistration', {status: res.lead_status})
            pushFBEvent('trackCustom', 'API', {status: res.lead_status})
            pushGTMEvent({'event': 'APISubmitted'})
            if (res.redirect_url.match(/dineo.es/gmi) != null) {
              var code = GetURLParameter('code', res.redirect_url),
                l_amount = GetURLParameter('l_amount', res.redirect_url),
                l_term = GetURLParameter('l_term', res.redirect_url),
                bank_account_number = GetURLParameter('bank_account_number', res.redirect_url),
                htmlcode = '<form id="iframeForm" target="iframe" action="' + (window.iframe_dineo ? window.iframe_dineo : 'https://www.dineo.es/iframe/crezu') + '" method="POST">\
                                            <input type="hidden" name="l_amount" value="' + l_amount + '"/>\
                                            <input type="hidden" name="l_term" value="' + l_term + '"/>\
                                            <input type="hidden" name="key" value="' + code + '"/>\
                                            <input type="hidden" name="account_bank" value="' + bank_account_number + '"/>\
                                            <input type="hidden" name="iframe" value="fc2aa34a"/></form>\
                                            <iframe name="iframe" style="display: none; min-height: 770px;" class="result_link_iframe" onload="$(this).show(); $(\'#loader\').remove();" src=""></iframe>';
              $('form').hide().before(htmlcode);
              $('body').prepend('<div id="loader"><div class="lds-ring"><div></div><div></div><div></div><div></div></div></div>');
              $('#iframeForm').submit();
            } else {
              $('form').hide().before('<iframe src="' + res.redirect_url + '" class="result_link_iframe"></iframe>');
              $('.apl-account-navbar').hide()
            }
            window.scrollTo(0, 0);
          } else if (res.display == 'feed') {
            // FB event when we redirect lead to offers
            pushFBEvent('track', 'CompleteRegistration', {status: res.lead_status})
            pushFBEvent('trackCustom', 'Feed', {status: res.lead_status})
            if (window.location.hostname === "crezu.kz") {
              var _tmr = window._tmr || (window._tmr = []);
              _tmr.push({id: "3162810", type: "reachGoal", goal: "conversion", value: 1});
            }
            goToFeed()
          } else if (res.display == 'feed_promo') {
            // FB event when we redirect lead to offers
            pushFBEvent('track', 'CompleteRegistration', {status: res.lead_status})
            pushFBEvent('trackCustom', 'Feed', {status: res.lead_status})
            pushGTMEvent({'event': 'feedSubmitted'})
            goToFeedPromo()
          } else if (res.display == 'redirect') {
            // FB event when we redirect lead to lender
            pushFBEvent('track', 'CompleteRegistration', {status: res.lead_status})
            pushFBEvent('trackCustom', 'API', {status: res.lead_status})
            pushGTMEvent({'event': 'APISubmitted'})
            if (res.redirect_url == "") {
              call_ajax_form()
            } else {
              if (window.location.hostname === "crezu.kz") {
                var _tmr = window._tmr || (window._tmr = []);
                _tmr.push({id: "3162810", type: "reachGoal", goal: "conversion", value: 1});
              }
              redirectSwitch(res, country)
            }
          } else if (res.customer) {
            // FB event when lead complete first step
            pushFBEvent('track', 'Lead', {status: res.lead_status})
            // request is /verify. function to handle autofill
            proceedVerifyResponse(res)
          } else if (res.display == 'curadeuda') {
            window.location.href = '/iframe/curadeuda';
          } else if (res.display == 'clear_confirm') {
            showLoader();
            hardRefreshPage()
          }
        }
      },
      error: function (data) {
        hideLoader()
        var err = data.responseJSON.errors;
        if (err[0].validation) {
          err[0].validation = Array.isArray(err[0].validation) ? err[0].validation : [err[0].validation]
          if (country.is_AR && (err[0].validation.indexOf('phone') > -1)) {
            err[0].validation[err[0].validation.indexOf('phone')] = 'ar-phone-code'
            err[0].validation.push('ar-phone')
          }
          if (err[0].validation.indexOf('work_start_date') > -1) {
            err[0].validation[err[0].validation.indexOf('work_start_date')] = 'work_start_year'
          }
          var first = true;
          $.each(err[0].validation, function (i, field_name) {
            // new additional logic, if backend returns validation error of field, what did not even requested and rendered!
            if (step_required_fields.indexOf(field_name) == -1) {
              if (field_name == 'confirm') {
                $('[name=' + field_name + ']').closest('.ui-form__row').prev('.field_label-text').removeClass('hidden');
              }
              // Show row title if exist
              $('[name=' + field_name + ']').closest('.ui-form__row').prev('.ui-form__row_title').removeClass('hidden');
              $('[name=' + field_name + ']').prop('disabled', false).closest('.ui-form__row').removeClass('hidden');
            }
            // end of this awesome logic

            trigger_err($('[name=' + field_name + ']').closest('.ui-form__field'));
            if (first) {
              if (field_name == 'id_number') {
                $('html,body').stop().animate({
                  scrollTop: 0
                }, 300);
              } else {
                $('html,body').stop().animate({
                  'scrollTop': $('[name=' + field_name + ']').offset().top - ($('.progress_bar_wrapper').length > 0 ? $('.progress_bar_wrapper').parent('.progress_bar_holder').outerHeight() : 0)
                }, 300);
              }
              first = false;
            }
          });
          if (!$('.app-form-action-buttons .app-form-action-buttons').prev('.ui-form-field-error-message').length > 0 && !$('[name=confirm_email]').val())
            $('.app-form-action-buttons .app-form-action-buttons').before('<div class="ui-form-field-error-message ui-form-field-error-message_ui-form">' + fields_json.params.form_error + '</div>');
          if (err[0].validation.indexOf("email") > -1) {
            $('[name=email_repeat]').attr("disabled", false)
          }
        } else if (err[0].critical || err[0].verification) {
          hardRefreshPage()
        }
        setTimeout(function () {
          $('.box-wrapper').removeClass('hidden');
        }, 100)
      }
    });
  }

  showLoader();

  // recaptcha test for ES and MX
  // if ((method.indexOf("/form") > -1) && ($('[name=provider]').val()==2 || $('[name=provider]').val()==3)) {

  // recaptcha test for ALL domains
  if (method.indexOf("/form") > -1 && (country.is_ES || country.is_MX)) {
    try {
      grecaptcha.execute('6LcqgK4UAAAAAO53lS01cuVjnkpuu4erVgDwrZIV', {action: 'homepage'}).then(function (token) {
        postData.push({
          'name': 're_token',
          'value': token
        })
        sendRequest()
      }, function (reason) {
        console.warn('captcha error', reason)
        sendRequest()
      })
    } catch (e) {
      console.error('problems with captcha init', e)
      sendRequest()
    }
  } else {
    // standart flow
    sendRequest()
  }
}

// func to handle verify response and autofill fields
function proceedVerifyResponse(res) {
  var fieldsForNextStep = []
  for (var field in res.customer) {
    if (res.customer[field]) {
      fieldsForNextStep.push(field)
    }
  }
  $.when(setupNextStep(fieldsForNextStep, res.lead_id)).then(function () {
    autocompleteFieldsWithData(res.customer)
    $('html,body').stop().animate({
      scrollTop: 0
    }, 300);
  }, function () {
    console.log("error")
  });
}

// func to handle verify response and autofill fields
function processAuthAutocomplete(data) {
  if (standartFlow) {
    var fieldsForNextStep = []

    // push id_number field
    if (!data['id_number'] && country.is_ES) {
      fieldsForNextStep.push("id_number")
    }
    if (!data['loan_sum']) {
      data['loan_sum'] = 1
    }
    if (!data['loan_period']) {
      data['loan_period'] = 30
    }

    for (var field in data) {
      if (data[field]) {
        if (field == 'phone' && country.is_AR) {
          console.log('skip phone')
        } else {
          fieldsForNextStep.push(field)
        }
      }
    }
    const leadId = localStorage.getItem('leadId') || localStorage.getItem('lead_id')
    $.when(setupNextStep(fieldsForNextStep, leadId)).then(function () {
      autocompleteFieldsWithData(data)
      $('html,body').stop().animate({
        scrollTop: 0
      }, 300);
      console.log('remove loader from processAuthAutocomplete, cause success')
      $('#loader').remove();
      dispatchCrezuEvent('formLoaded')
      if (!country.is_ES) {
        authAnalyticsEvents()
        setTimeout(function () {
          $('.box-wrapper').addClass('hidden')
          call_ajax_form()
        }, 100)
        console.log('auth v2, so we go to /process endpoint')
      }
    }, function () {
      console.log('remove loader from processAuthAutocomplete, cause error')
      $('#loader').remove();
      dispatchCrezuEvent('formLoaded')
    });
  } else {
    console.log(`remove loader from processAuthAutocomplete, cause ${standartFlow ? 'unsupported country' : 'not standart flow'}`)
    $('#loader').remove();
    dispatchCrezuEvent('formLoaded')
  }
}

// func to autocomplete fields
function autocompleteFieldsWithData(data) {
  autocompleteData = data
  for (var field in data) {
    if (data[field]) {
      var inp = $("[name=" + field + "]");
      if (data[field] === true) {
        data[field] = '1'
      } else if (data[field] === false) {
        data[field] = '0'
      }
      if (inp.attr("is-new-select")) { // && data[field]
        if (country.is_ES) {
          if (["province", "city", "zip"].indexOf(field) == -1) {
            newSelectUpdate(field, swapDict(translateDict[field])[data[field]])
          } else {
            if (field == "province") {
              newSelectUpdate(field, data[field])
            }
          }
        } else if (country.is_MX) {
          if (field != "colony") {
            newSelectUpdate(field, swapDict(translateDict[field])[data[field]])
          }
        } else {
          newSelectUpdate(field, swapDict(translateDict[field])[data[field]])
        }
      } else {
        if (inp.attr('type') == "radio") {
          inp.filter('[value=' + data[field] + ']').prop('checked', true).closest('.radio').addClass('checked');
          inp.trigger('change')
        } else {
          // if (data[field]) {
          if (field == "phone") {
            data[field] = "+" + data[field]
          }
          if (field == "work_start_date") {
            var workStartMonth = data[field].split("-")[1]
            newSelectUpdate("work_start_month", swapDict(translateDict["work_start_month"])[workStartMonth])
            var workStartYear = data[field].split("-")[2]
            $("[name=work_start_year]").val(workStartYear).focus().focus().blur()
            trigger_success($("[name=work_start_year]").closest('.ui-form__field'));
          }
          inp.val(data[field]).focus().focus().blur().blur()
          trigger_success(inp.closest('.ui-form__field'));
          if (field == "bank_account_number" || field == "phone") {
            inp.trigger("keyup")
            if (data[field] === 'IGNORE') {
              $(`[name=${field}]`).closest('.ui-form__row').addClass('hidden')
              $('.beneciarios-divider').hide()
            }
          }
          if (country.is_MX) {
            if (field == 'email') {
              $("[name=email_repeat]").focus();
              $("[name=email_repeat]").val(data[field]);
              $("[name=email_repeat]").blur();
            } else if (field == 'zip') {
              $("[name=zip]").trigger('input')
            }
          }
          // }
        }
      }
    }
  }
  setTimeout(function () {
    $('#loan_sum_range').val($('[name=loan_sum]').val()).trigger('input')
  }, 1000)
}

// func to select value in new select
function newSelectUpdate(field_name, field_val) {
  $('.selector-' + field_name)[0].update({value: field_val})
  $('#valueof-' + field_name).val(field_val)
  $('#success-' + field_name).removeClass('hidden')
  trigger_success($('[name=' + field_name + ']').closest('.ui-form__field'))
}

function initializeJuicyScore() {
  const juicyUrl = is_staging ? 'https://score.juicyscore.net/static/js.js' : 'https://score.juicyscore.com/static/js.js'
  const juicyLabConfig = {
    nextButton: '.app-form-forward-button'
  }
  window.juicyLabConfig = juicyLabConfig
  const s = document.createElement('script')
  s.type = 'text/javascript'
  s.async = true
  s.src = juicyUrl
  s.onload = getJuicyScoreSession
  const x = document.getElementsByTagName('head')[0]
  x.appendChild(s)

  function getJuicyScoreSession () {
    window.juicyScoreApi.getSessionId().then(
      function(s) {
        localStorage.setItem('juicescore_session_id', s)
      }
    )
  }
}

function initializeUnnaxWidget(url, provider) {
  $('#pl').closest('.ui-form__row').addClass('hidden')
  if (provider === 'moneyman') localStorage.setItem('online_banking_provided', '0')
  showLoader()
  setTimeout(hideLoader, 3000)
  console.log('UNNAX URL:', url, 'provider:', provider)
  $('.app-form-forward-button').fadeOut()
  $('#unnax').attr('src', url).closest('.ui-form__row').removeClass('hidden')

  const eventMethod = window.addEventListener ? 'addEventListener' : 'attachEvent'
  const eventer = window[eventMethod]
  const messageEvent = eventMethod === 'attachEvent' ? 'onmessage' : 'message'

  // Listen to message from child window
  eventer(messageEvent,function(e) {
    if (e.data === 'unnax:aggregation:done'){
      console.log('UNNAX DONE:', e)
      if (provider === 'moneyman') {
        try {
          jslabApi.manuallyComplete.dispatchEvent(new Event('click'))
        } catch (e) {
        }
        localStorage.setItem('online_banking_provided', '1')
      } else if (provider === 'welp') {
        localStorage.setItem('wenance_bank_reader', 1)
      }
      setTimeout(function () {
        $('#unnax').closest('.ui-form__row').addClass('hidden')
        $('.app-form-forward-button').fadeIn()
      }, 3000)
      call_ajax_form()
    } else if (e.data === 'unnax:aggregation:fail') {
      console.log('UNNAX FAIL:', e)
    }
  })
  $('#has_declined_unnax').click(function () {
    call_ajax_form()
    if (provider === 'welp') {
      localStorage.setItem('wenance_bank_reader', 0)
    }
    // enable button continue after skip
    $('.app-form-forward-button').fadeIn()
  });
}

function initializePaylands(token) {
  console.log('token:', token)
  $('.app-form-forward-button').fadeOut()
  showLoader()
  setTimeout(hideLoader, 2000)
  let sandboxPrefix = is_staging ? '/sandbox' : ''
  let iframeLink = `https://ws-paylands.paynopain.com/v1${sandboxPrefix}/payment/process/${token}`
  $('#pl').attr('src', iframeLink).closest('.ui-form__row').removeClass('hidden')
  window.addEventListener('message', function (e) {
    switch (e.data) {
      case 'PAYLANDS-SUCCESS':
        pushGTMEvent({
          "event": "paylandsComplete"
        })
        console.log('PROCESS FINISHED')
        $("#paylands-container").removeClass("paylands-invalid")
        $("#paylands-container").addClass("paylands-valid")
        $('#pl').closest('.ui-form__field').find('.ui-form-field-error-message').addClass('hidden')
        localStorage.setItem('paylands_provided', '1')
        // call_ajax_form()
        initializeUnnaxWidget(localStorage.getItem('unnax_url'), 'moneyman')
        break;
      case 'PAYLANDS-ERROR':
        // todo: show error message, request
        console.log('PROCESS ERROR')
        initializeUnnaxWidget(localStorage.getItem('unnax_url'), 'moneyman')
        // call_ajax_form()
        // token again
        // or skip (when allowed)
        break;
    }
  });
}

function initializeInstantor(name, provider, token, redirect_url) {
  pushGTMEvent({
    "event": "instantorInit"
  })
  showLoader()
  // $.getScript('https://www.instantor.se/frame-loader/instantor-0.7.3.min.js', function () {
  $.getScript('https://frame.euc1.instantor.com/instantor-0.7.3.min.js', function () {
    hideLoader()
    try {
      var instantorCallbackCalles = false
      showLoader()
      if (name === 'moneyman' || name === 'welp') {
        $('.has_declined_instantor_shower').removeClass('hidden')
      }
      var itor = new Instantor(provider);
      if (token) {
        if (name === 'twinero') itor.userParam('applicationUuid', token);
        if (name === 'welp') {
          itor.userParam('userId', token)
          itor.frameParam('disableFinalStep', 'true')
        }
      }
      itor.userParam('firstName', localStorage.getItem('firstName'));
      itor.userParam('lastName', localStorage.getItem('lastName'));
      itor.userParam('lead_id', localStorage.getItem('leadId') || localStorage.getItem('lead_id'));
      if (window.location.hostname.indexOf('staging') > -1) itor.userParam('environment', 'stage')
      itor.load('#itor');
      setTimeout(function () {
        $('#itor').closest('.ui-form__row').removeClass('hidden')
        hideLoader()
      }, 1000)
      $('.app-form-forward-button').prop('disabled', true)
      itor.listener(function (response) {
        switch (response) {
          case 'process-finished':
            if (!instantorCallbackCalles) {
              pushGTMEvent({
                "event": "instantorComplete"
              })
              if (redirect_url) {
                showLoader()
                proceedRedirect(redirect_url)
              }
              localStorage.setItem('instantor_provided', 1)
              if (name === 'twinero') {
                $('.app-form-forward-button').prop('disabled', false)
              } else if (name === 'moneyman') {
                // call_ajax_form()
                pushGTMEvent({
                  "event": "paylandsInit"
                })
                $('#pl').closest('.ui-form__row').removeClass('hidden')
                if (+localStorage.getItem('paylands_required')) {
                  $('.has_declined_paylands_shower').removeClass('hidden')
                  // $('.has_declined_paylands_shower').addClass('hidden');
                  // setTimeout(function () {
                  //   $('.has_declined_paylands_shower').removeClass('hidden')
                  // }, 10000)
                }
              } else if (name === 'welp') {
                call_ajax_form()
              }
              $('#itor').closest('.ui-form__row').addClass('hidden')
              instantorCallbackCalles = true
            }
            break;
          case 'invalid-login':
            /* User did not provide correct login credentials. */
            break;
          default:
            /* Process encountered an error. */
            if (redirect_url) {
              showLoader()
              proceedRedirect(redirect_url)
            }
            break;
        }
      });
    } catch (err) {
      console.error('Error!' + err);
      // if (name === 'moneyman') {
      //   $('#pl').closest('.ui-form__row').removeClass('hidden')
      //   $('#itor').closest('.ui-form__row').addClass('hidden')
      // } else
      if (redirect_url) {
        proceedRedirect(redirect_url)
      } else {
        call_ajax_form()
      }
    }
  })
}

function setupNextStep(fields, lead_id) {
  console.log('SETUP NEXT STEP:', fields)
  window.curr_step = window.curr_step + 1;
  if (window.interface_v2 && window.curr_step > 1) {
    $('.ui-form-field-note-message').fadeOut()
  }
  clearProgressbar();
  if (window.curr_step == 1) {
    $('.app-form-action-agreement').addClass('hidden');
    $('.topbar').text(fields_json.params.topbar.introduce_per);
  } else {
    if (fields.indexOf('confirm') > -1) {
      $('.topbar').text(fields_json.params.topbar.phone_verification);
    } else if (fields.indexOf('confirm_email') > -1) {
      $('.topbar').text(fields_json.params.topbar.email_verification);
      var emailInp = $('[name=email]').val()
      var currEmail = (emailInp ? emailInp : localStorage.getItem('email')) || ''
      $('#email-copy').text(currEmail)
      if (currEmail.indexOf('@gmail.com') > -1) {
        $('.to_spam_link').removeClass('hidden')
      }
    } else {
      $('.topbar').text(fields_json.params.topbar.introduce);
      $('.field_label-text').addClass('hidden');
    }
  }

  formFillStart = (Date.now() / 1000 | 0)

  // Time log for GTM event on second step
  if (fields.indexOf('id_number') > -1) {
    var focusTimer = function () {
      pushGTMEvent({
        "event": "TimeToFieldTyping",
        "value": (Date.now() / 1000 | 0) - formFillStart,
        "lead_id": localStorage.getItem('leadId') || localStorage.getItem('lead_id')
      });
      $('input').unbind('focus', focusTimer)
    };
    $('input').bind('focus', focusTimer)
  }

  // Work start date split to 2 fields
  if (fields.indexOf('work_start_date') > -1) {
    fields.splice(fields.indexOf('work_start_date'), 1)
    fields.push('work_start_month')
    fields.push('work_start_year')
  }

  // Prestamer block
  if (fields.indexOf('prestamer_agreements') > -1) {
    fields.splice(fields.indexOf('prestamer_agreements'), 1)
    fields.push('prestamer_agreement1')
    fields.push('prestamer_agreement2')
  }

  // Moneyman agreements block
  if (fields.indexOf('moneyman_agreements') > -1) {
    if (window.location.hostname === 'crezu.es') {
      (function(h,o,t,j,a,r){
        h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
        h._hjSettings={hjid:2858357,hjsv:6};
        a=o.getElementsByTagName('head')[0];
        r=o.createElement('script');r.async=1;
        r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
        a.appendChild(r);
      })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
    }
    fields.splice(fields.indexOf('moneyman_agreements'), 1)
    fields.push('moneyman1')
    fields.push('moneyman2')
    fields.push('moneyman3')
    var params = {lead_id: localStorage.getItem('leadId') || localStorage.getItem('lead_id')}
    $.ajax({
      url: backendurl + '/customer/token',
      type: 'post',
      dataType: 'json',
      data: params,
      success: function (data) {
        if (data.is_success) {
          localStorage.setItem('paylands_required', '1')
          initializeJuicyScore()
          try {
            var dataJson = JSON.parse(data.data)
            localStorage.setItem('paylands_required', dataJson.paylands_required)
            localStorage.setItem('online_banking_required', dataJson.online_banking_required)
          } catch (e) {
            var dataJson = {contract: '', instantor_required: 1}
          }
          $('#moneyman-contract').attr("href", dataJson.contract)
          // if (!dataJson.instantor_required) {
          //   console.log('skip instantor because API_v2')
          //   window.skip_instantor_v2 = true
          // }
          if (dataJson.paylands_required) $('.has_declined_paylands_shower').fadeOut()
          if (dataJson.online_banking_required) $('.has_declined_online_banking_shower').fadeOut()
        }
      }
    });
    // show confirm additional info about contract
    var sum = +localStorage.getItem('loan_sum') || 300
    var per = +localStorage.getItem('loan_period') || 30
    $('.confirm-additional-info').removeClass('hidden');
    $('.confirm-additional-info').html('<b>Tiene disponible ' + ((sum > 300) ? 300 : sum) + ' euros a devolver en ' + ((per > 30) ? 30 : per) + ' días sin intereses</b>')
  } else {
    // hide confirm additional info about contract
    $('.confirm-additional-info').addClass('hidden');
  }

  if (fields.indexOf('has_car') > -1) {
    for (let i in carFieldsHardcore) {
      let index = fields.indexOf(carFieldsHardcore[i])
      if (index > -1) fields.splice(index, 1)
    }
  }

  // Lender-picker
  if (fields.indexOf('lender-picker') > -1) {
    renderLenderPicker($('[name=country]').val(), lead_id)
  } else {
    $('.lender-picker').remove()
  }

  if ((localStorage.getItem('authAutocomplete') || localStorage.getItem('JWTAutocomplete')) && standartFlow) {
    if (fields.indexOf('id_number') > -1 && country.is_ES) {
      secondStepPrepareAfterAuth()
      fields.push('loan_sum')
      fields.push('loan_purpose')
    } else {
      $('#cloneOfSubmit').remove()
      $('.authHeader').remove()
      $('.topbar.text-center').removeClass('hidden')
      $('.progress_bar_holder').removeClass('hidden')
    }
  }
  $('#lead_id_input').val(lead_id);
  $('.topbar .step').text(window.curr_step);
  $('.formcontent .ui-form__row').not('.hidden').each(function () {
    $(this).addClass('hidden');
    $(this).find('input').prop('disabled', true).prop('checked', false).val('');
  });

  // Send all field what backend is request to make deviders exactly on needle field, not on hidden unusable first field in column.
  setUpDeviders(fields);

  $.each(fields, function (i, field) {
    if (field == 'confirm') {
      $('[name=' + field + ']').closest('.ui-form__row').prev('.field_label-text').removeClass('hidden');
    }
    $('[name=' + field + ']').prop('disabled', false).closest('.ui-form__row').removeClass('hidden');
  });

  // Scroll to top of needle fields
  $('html,body').stop().animate({
    scrollTop: 0
  }, 300);

  trigger_percentreward(false);
  $('.app-form-action-buttons .ui-form-field-error-message').addClass('hidden');
  if (fields.indexOf('confirm_email') == -1 && fields.length) {
    setTimeout(function () {
      $('.box-wrapper').removeClass('hidden');
    }, 100)
  }

  //disable new-select inputs
  if (country.is_ES) {
    $('[name=zip]').attr('disabled', true)
    $('[name=city]').attr('disabled', true)
  } else if (country.is_MX) {
    $('[name=colony]').attr('disabled', true)
    $('[name=city]').attr('disabled', true)
    $('[name=city]').closest('.ui-input__container').css({background: "#e8e8e8"})
    $('[name=municipality]').attr('disabled', true)
    $('[name=municipality]').closest('.ui-input__container').css({background: "#e8e8e8"})
    $('[name=state]').attr('disabled', true)
    $('[name=state]').closest('.ui-input__container').css({background: "#e8e8e8"})

    $('[name=other_loans_amount]').prop('disabled', true).closest('.ui-form__row').addClass('hidden');
    $('[name=other_loans_company]').prop('disabled', true).closest('.ui-form__row').addClass('hidden');
  }
  var fieldsMass = Object.keys(translateDict)
  for (var i in fieldsMass) {
    if (fields.indexOf(fieldsMass[i]) > -1 && fieldsMass[i] != "bank_code") {
      $('[name=' + fieldsMass[i] + ']').attr('disabled', true)
    }
  }
  step_required_fields = fields

  // Moneyman instantor block
  // if (fields.indexOf('moneyman_instantor') > -1) {
  //   localStorage.setItem('instantor_provided', 0)
  //   // var declineMoneymanInstantor = function () {
  //   //   $('#pl').closest('.ui-form__row').removeClass('hidden')
  //   //   $('#itor').closest('.ui-form__row').addClass('hidden')
  //   // }
  //   // $('#has_declined_instantor').unbind('click')
  //   // $('#has_declined_instantor').click(function () {
  //   //   declineMoneymanInstantor()
  //   // });
  //   // if (window.skip_instantor_v2) {
  //   //   declineMoneymanInstantor()
  //   //   $('.app-form-forward-button').prop('disabled', true)
  //   // } else {
  //   //   initializeInstantor('moneyman', 'moneyman-standardproduct-cffa75b6b91e.es')
  //   // }
  //   $('#has_declined_instantor').click(function () {
  //     pushGTMEvent({
  //       "event": "instantorSkip"
  //     })
  //     call_ajax_form()
  //   });
  //   if (window.skip_instantor_v2) {
  //     call_ajax_form()
  //   }
  //
  //   initializeInstantor('moneyman', 'moneyman-standardproduct-cffa75b6b91e.es')
  //   // hide hint for Paylands cardholder name
  //   $('.ui-form-progress-bar__hint .cont').hide();
  // }
  // Moneyman paylands block
  if (fields.indexOf('moneyman_paylands') > -1) {
    localStorage.setItem('paylands_provided', '0')
    $('#has_declined_paylands').click(function () {
      pushGTMEvent({
        "event": "paylandsSkip"
      })
      // call_ajax_form()
      initializeUnnaxWidget(localStorage.getItem('unnax_url'), 'moneyman')
      // enable button continue after skip
      $('.app-form-forward-button').fadeOut()
    });
    $.ajax({
      url: backendurl + '/customer/token',
      type: 'post',
      dataType: 'json',
      data: {lead_id: localStorage.getItem('leadId') || localStorage.getItem('lead_id')},
      success: function (data) {
        if (data.is_success) {
          const parsedData = JSON.parse(data.data)
          initializePaylands(parsedData.paylands_customer_token)
          localStorage.setItem('unnax_url', parsedData.unnax_url)
          localStorage.setItem('online_banking_id', parsedData.online_banking_id)
        }
      },
      error: function (e) {
        call_ajax_form()
      }
    });
  }
  // Twinero instantor block
  if (fields.indexOf('twinero_instantor') > -1) {
    var params = {lead_id: localStorage.getItem('leadId') || localStorage.getItem('lead_id')}
    $.ajax({
      url: backendurl + '/customer/token',
      type: 'post',
      dataType: 'json',
      data: params,
      success: function (data) {
        if (data.is_success) {
          initializeInstantor('twinero', 'prestamosprima-twinero-41235f40-ebe4-11e8-8eb2-f2801f1b9fd1.es', data.data, localStorage.getItem('twinero_redirect_url'))
        } else {
          proceedRedirect(localStorage.getItem('twinero_redirect_url'))
        }
      },
      error: function (error) {
        proceedRedirect(localStorage.getItem('twinero_redirect_url'))
      }
    });
    fields.splice(fields.indexOf('twinero_instantor'), 1)
  }

  // Welp instantor block
  if (fields.indexOf('welp_instantor') > -1) {
    localStorage.setItem('instantor_provided', 0)
    var params = {lead_id: localStorage.getItem('leadId') || localStorage.getItem('lead_id')}
    $.ajax({
      url: backendurl + '/customer/token',
      type: 'post',
      dataType: 'json',
      data: params,
      success: function (data) {
        $('#has_declined_instantor').click(function () {
          call_ajax_form()
        });
        var userId = GetURLParameter('userId', data.data)
        var env = GetURLParameter('env', data.data)
        console.log('init Welp instantor, userId:', userId, 'env:', env)
        initializeInstantor('welp', 'wenance.es', userId)
      },
      error: function (error) {
        call_ajax_form()
      }
    });
  }

  // Welp wenance_bank_reader
  if (fields.indexOf('wenance_bank_reader') > -1) {
    $.ajax({
      url: backendurl + '/customer/token',
      type: 'post',
      dataType: 'json',
      data: {lead_id: localStorage.getItem('leadId')},
      success: function (data) {
        console.log('TOKEN:', data)
        try {
          const url = JSON.parse(data.data).bank_login_render_url
          initializeUnnaxWidget(url, 'welp')
        } catch (e) {
          localStorage.setItem('wenance_bank_reader', 0)
          call_ajax_form()
        }
      },
      error: function (error) {
        localStorage.setItem('wenance_bank_reader', 0)
        call_ajax_form()
      }
    });
  }
}

// Showing all modals
function showmodal(modal_name) {
  $('.modal#' + modal_name).css({
    'top': 0,
  }).addClass('in');
  $('html').addClass('locked');
  $('.modal.in#' + modal_name).find('.content').css('height', $(window).height() - parseInt($('.modal.in').css('padding-top')) - parseInt($('.modal.in').css('padding-bottom')));
}

function resizeModals() {
  $('.modal.in').find('.content').css('height', $(window).height() - parseInt($('.modal.in').css('padding-top')) - parseInt($('.modal.in').css('padding-bottom')));
}

function loadZip(city) {
  if (!city) {
    return
  }
  $.ajax({
    url: backendurl + '/address/' + ((country.is_ES) ? 'es/' : '') + 'zip?city=' + city,
    dataType: 'json',
    success: function (data) {
      if (data.data) {
        ajaxZips = data.data.zip
        var jsonZips = []
        for (var i in ajaxZips) {
          jsonZips.push({zip: ajaxZips[i]})
        }
        $('[name=zip]').prop('disabled', false).closest('.ui-form__row').removeClass('disabled');
        var zip_values = []
        for (var i in data.data.zip) {
          zip_values.push({value: data.data.zip[i], label: data.data.zip[i]})
        }
        $('.selector-zip')[0].update({disabled: false, hidden: false, values: zip_values})
        $('.selector-zip')[0].onChange(function (result) {
          if (ajaxZips.indexOf(result) > -1) {
            $('#success-zip').removeClass('hidden')
          } else {
            $('#success-zip').addClass('hidden')
          }
          leaveField_timing(this.name, 'change')
        })
        $('.selector-zip')[0].onFocus(function (e) {
          $([document.documentElement, document.body]).animate({
            scrollTop: $('.selector-zip').offset().top - 106
          }, 300);
          enterField_timing(this.name)
        })
        if (data.data.zip.length == 1) {
          newSelectUpdate("zip", data.data.zip[0])
          $('[name=zip]').attr('disabled', true)
        } else if (data.data.zip.length < 10) {
          $('[name=zip]').attr('disabled', true)
        } else if (data.data.zip.length >= 10) {
          $('[name=zip]').attr('disabled', false)
        }
        // new block for /verify autofill
        if (autocompleteData.zip && data.data.zip.length > 1) {
          newSelectUpdate("zip", autocompleteData.zip)
        }
      }
    }
  });
}

function loadCity(province) {

  $.ajax({
    url: backendurl + '/address/' + ((country.is_ES) ? 'es/' : '') + 'city?province=' + province,
    dataType: 'json',
    success: function (data) {

      if (data.data) {
        ajaxCities = data.data.city
        var jsonCities = []
        for (var i in ajaxCities) {
          jsonCities.push({city: ajaxCities[i]})
        }
        $('[name=city]').prop('disabled', false).closest('.ui-form__row').removeClass('disabled');
        var city_values = []
        for (var i in data.data.city) {
          city_values.push({value: data.data.city[i], label: data.data.city[i]})
        }
        $('.selector-city')[0].update({disabled: false, hidden: false})
        $('.selector-city')[0].update({values: city_values})
        $('.selector-city')[0].onChange(function (result) {
          $('[name=zip]').val('');
          $('.selector-zip')[0].update({value: '', values: []})
          $('#success-zip').addClass('hidden')
          loadZip(result);
          if (ajaxCities.indexOf(result) > -1) {
            $('#success-city').removeClass('hidden')
          } else {
            $('#success-city').addClass('hidden')
          }
          leaveField_timing(this.name, 'change')
        })
        $('.selector-city')[0].onFocus(function (e) {
          $([document.documentElement, document.body]).animate({
            scrollTop: $('.selector-city').offset().top - 106
          }, 300);
          enterField_timing(this.name)
        })
        // new block for /verify autofill
        if (autocompleteData.city) {
          newSelectUpdate("city", autocompleteData.city)
        }
      }
    }
  });
}

function generateProvinceField() {
  var province_values = []
  for (var i in ajaxProvinces) {
    province_values.push({value: ajaxProvinces[i], label: ajaxProvinces[i]})
  }
  $('.selector-province')[0].update({disabled: false, hidden: false, values: province_values})
  $('.selector-province')[0].onChange(function (result) {
    $('[name=city]').val('');
    $('.selector-city')[0].update({value: '', values: []})
    $('[name=zip]').val('');
    $('.selector-zip')[0].update({value: '', values: [{value: zip_placeholder, label: zip_placeholder}]})
    $('.selector-zip')[0].update({disabled: true})
    $('#success-city').addClass('hidden')
    loadCity(result);
    if (ajaxProvinces.indexOf(result) > -1) {
      $('#success-province').removeClass('hidden')
    } else {
      $('#success-province').addClass('hidden')
    }
    leaveField_timing(this.name, 'change')
  })
  $('.selector-province')[0].onFocus(function (e) {
    $([document.documentElement, document.body]).animate({
      scrollTop: $('.selector-province').offset().top - 106
    }, 300);
    enterField_timing(this.name)
  })
  $('[name=province]').attr("autocomplete", "new-password");
}

function loadColony(zip, cont) {
  if (zip.length == 5) {
    $.ajax({
      url: backendurl + '/address/mx?zip=' + zip,
      dataType: 'json',
      success: function (data) {
        if (data.is_success) {
          ajaxColonies = []
          var jsonColonies = []
          var dictColonies = {}
          for (var i in data.data.colonies) {
            jsonColonies.push({colony: data.data.colonies[i].colony})
            ajaxColonies.push(data.data.colonies[i].colony)
            dictColonies[data.data.colonies[i].colony] = data.data.colonies[i]
          }
          $('[name=colony]').prop('disabled', false).closest('.ui-form__row').removeClass('disabled');
          var colony_values = []
          for (var i in data.data.colonies) {
            colony_values.push({value: data.data.colonies[i].colony, label: data.data.colonies[i].colony})
          }
          $('.selector-colony')[0].update({disabled: false, hidden: false})
          $('.selector-colony')[0].update({values: colony_values})
          $('.selector-colony')[0].onChange(function (result) {
            if (ajaxColonies.indexOf(result) > -1) {
              $('#success-colony').removeClass('hidden')
              $('[name=city]').focus()
              $('[name=city]').val(dictColonies[result].city)
              $('[name=city]').blur()
              $('[name=municipality]').focus()
              $('[name=municipality]').val(dictColonies[result].municipality)
              $('[name=municipality]').blur()
              $('[name=state]').focus()
              $('[name=state]').val(dictColonies[result].state)
              $('[name=state]').blur()
            } else {
              $('#success-colony').addClass('hidden')
            }
            leaveField_timing(this.name, 'change')
          })
          if (ajaxColonies.length == 1) {
            $('.selector-colony')[0].update({value: ajaxColonies[0]})
            $('#valueof-colony').val(ajaxColonies[0])
            $('#success-colony').removeClass('hidden')
            trigger_success($('[name=colony]').closest('.ui-form__field'))
          }
          $('.selector-colony')[0].onFocus(function (e) {
            $([document.documentElement, document.body]).animate({
              scrollTop: $('.selector-colony').offset().top - 106
            }, 300);
            enterField_timing(this.name)
          })
          // new block for /verify autofill
          if (autocompleteData.colony) {
            newSelectUpdate("colony", autocompleteData.colony)
          }

        } else {
          $('.selector-colony')[0].update({value: '', values: []})
          resetColonyMX()
        }
      },
      error: function (error) {
        $('.selector-colony')[0].update({value: '', values: []})
        resetColonyMX()
      }
    });
  }
}

function zipHandlerMx() {
  $("[name=zip]").on('input', function (e) {
    resetColonyMX()
    $('[name=colony]').val('');
    $('.selector-colony')[0].update({value: '', values: [{value: colony_placeholder, label: colony_placeholder}]})
    $('.selector-colony')[0].update({disabled: true})
    if (e.target.value.length == 5) {
      loadColony(e.target.value);
    }
    $('.selector-colony')[0].update({value: '', values: [{value: colony_placeholder, label: colony_placeholder}]})

  })
}

function resetColonyMX() {
  $('[name=city]').closest('.ui-form__field').find('.ui-input__additional').html('');
  $('[name=city]').val('')
  $('[name=municipality]').closest('.ui-form__field').find('.ui-input__additional').html('');
  $('[name=municipality]').val('')
  $('[name=state]').closest('.ui-form__field').find('.ui-input__additional').html('');
  $('[name=state]').val('')
  $('#success-colony').addClass('hidden')

}

// ---------------------------------------------------------------------------------------------------------------------

function generateNewSelectField(fieldName) {
  var keys = Object.keys(translateDict[fieldName])
  var values = []
  for (var i in keys) {
    values.push({value: keys[i], label: keys[i]})
  }
  $('.selector-' + fieldName)[0].update({disabled: false, hidden: false, values: values})
  $('.selector-' + fieldName)[0].onChange(function (result) {
    if (keys.indexOf(result) > -1) {
      $('#success-' + fieldName).removeClass('hidden')
      trigger_success($('[name=' + fieldName + ']').closest('.ui-form__field'))
    } else {
      $('#success-' + fieldName).addClass('hidden')
    }
    leaveField_timing(this.name, 'change')
  })
  $('.selector-' + fieldName)[0].onFocus(function (e) {
    $([document.documentElement, document.body]).animate({
      scrollTop: $('.selector-' + fieldName).offset().top - 106
    }, 300);
    enterField_timing(this.name)
  })
}

export {
  setupNextStep,
  proceedRedirect,
  trigger_success,
  goToFeed,
  redirectSwitch,
  showLoader,
  hideLoader,
  newRedirectPopup,
  call_ajax_form
}
